import * as i0 from '@angular/core';
import { signal, computed, Directive } from '@angular/core';
import { isNotEmpty } from '@primeuix/utils';
import { BaseComponent } from 'primeng/basecomponent';
let BaseModelHolder = /*#__PURE__*/(() => {
  class BaseModelHolder extends BaseComponent {
    modelValue = signal(undefined, ...(ngDevMode ? [{
      debugName: "modelValue"
    }] : []));
    $filled = computed(() => isNotEmpty(this.modelValue()), ...(ngDevMode ? [{
      debugName: "$filled"
    }] : []));
    writeModelValue(value) {
      this.modelValue.set(value);
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵBaseModelHolder_BaseFactory;
      return function BaseModelHolder_Factory(__ngFactoryType__) {
        return (ɵBaseModelHolder_BaseFactory || (ɵBaseModelHolder_BaseFactory = i0.ɵɵgetInheritedFactory(BaseModelHolder)))(__ngFactoryType__ || BaseModelHolder);
      };
    })();
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: BaseModelHolder,
      features: [i0.ɵɵInheritDefinitionFeature]
    });
  }
  return BaseModelHolder;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { BaseModelHolder };
